import React from "react";
import { useCaptainTcCardConfig } from "../../hooks/useCaptainTcCardConfig";

const CaptainTCCashbackCardTerms = (props) => {
  const { cards } = useCaptainTcCardConfig();

  return (
    <section
      id="id_ico_about_section"
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <p className="text-dark fw-semibold opacity-50 mb-0">
                  Captain TC Collectible Cashback Card Terms & Conditions
                </p>
                <p className="text-dark fw-semibold opacity-50 mb-0">
                  Last updated: 07-06-2026
                </p>
                <p className="text-dark fw-semibold opacity-50 mb-0">
                  Company: TopCoin UK Ltd
                </p>
                <p className="text-dark fw-semibold opacity-50 mb-0">
                  Company Registration No: 16483297
                </p>
                <p className="text-dark fw-semibold opacity-50 mb-3">
                  Contact: info@topcoinuk.com
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">1. Who we are</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK Ltd (“TopCoin UK”) is an advertising, rewards, and
                  discount company registered in England & Wales (Company No.
                  16483297). TopCoin UK is not a cryptocurrency, gambling, or
                  investment business.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  2. What is a Captain TC Collectible Cashback Card?
                </h5>
                <p className="info_description text-dark opacity-50 mb-1">
                  A Captain TC Collectible Cashback Card is a special reward card offered
                  by TopCoin UK. It is designed to give card-holders access to
                  the Captain TC Collectible Cashback promotion.
                </p>
                <p className="info_description text-dark opacity-50 mb-1">
                  Each series of Captain TC cards contains 5,000 cards only.
                  Once a series has been fully completed, no more cards will be
                  issued in that series.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  There are three types of Captain TC Collectible Cashback Cards available
                  in the system: £5, £10, and £25.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">3. Cash Wallet Promotion</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  Every TopCoin collected in your Main Wallet is matched 1-for-1
                  and added to your Cash Wallet Card balance.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">4. Key definitions</h5>
                <ul className="text-dark opacity-50">
                  <li className="mb-2">
                    <strong>Captain TC Collectible Cashback Card</strong>
                    <br />
                    The digital or physical card you purchase to access the
                    Captain TC Cash-Wallet promotion.
                  </li>
                  <li className="mb-2">
                    <strong>Main Wallet</strong>
                    <br />
                    Your default TopCoin balance earned on eligible purchases.
                  </li>
                  <li className="mb-2">
                    <strong>Cash Wallet</strong>
                    <br />
                    The Cash Wallet is the wallet linked to your Captain TC
                    Cash-Wallet Card.
                  </li>
                  <li className="mb-2">
                    <strong>FCA-authorised payment partner</strong>
                    <br />
                    A licensed electronic-money or payment institution that
                    safeguards and pays out Cash Wallet funds on our behalf.
                  </li>
                </ul>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">5. Card options</h5>
                {cards.map((card, index) => (
                  <p
                    key={card.tier}
                    className={`info_description text-dark opacity-50 ${index < cards.length - 1 ? "mb-1" : "mb-0"}`}
                  >
                    <strong>{card.title}</strong>
                    <br />
                    You receive {card.purchase_topcoin} TopCoin when you purchase the card. Each time
                    you reach 250 TopCoin in your Captain TC Cash-Wallet
                    promotion, you become eligible to receive {card.eligible_label}. This can happen
                    up to 20 times, until you complete the 5,000 TopCoin Captain
                    TC Card promotion.
                  </p>
                ))}
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">6. Eligibility</h5>
                <ul className="text-dark opacity-50">
                  <li>You must be at least 16 years old.</li>
                  <li>You must provide a valid email address and mobile number.</li>
                  <li>
                    The programme is open worldwide. You do not need to be a UK
                    resident. Currency conversions for withdrawals are handled
                    by our FCA-authorised payment partner at their standard
                    exchange rates.
                  </li>
                </ul>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  7. Buying the card and cooling-off period
                </h5>
                <p className="info_description text-dark opacity-50 mb-1">
                  The card price is shown at checkout.
                </p>
                <p className="info_description text-dark opacity-50 mb-1">
                  You may cancel within 14 days for a full refund, provided you
                  have not used the card or redeemed any TopCoin linked to it.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  For cancellations, email info@topcoinuk.com.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">8. How TopCoin works</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  All TopCoin is funded entirely by commissions and discounts
                  supplied by participating merchants. Customers do not purchase
                  TopCoin with cash.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">9. Cash Wallet</h5>
                <ul className="text-dark opacity-50">
                  <li>
                    <strong>Pool structure</strong>
                    <br />
                    The Cash Wallet is a safeguarded payment structure operated
                    through our FCA-authorised payment partner.
                  </li>
                  <li>
                    <strong>Unlock trigger</strong>
                    <br />
                    Your Cash Wallet becomes available each time you reach 250
                    TopCoin in your Captain TC Cash-Wallet promotion.
                  </li>
                  <li>
                    <strong>Withdrawal</strong>
                    <br />
                    Once available, you may request withdrawal of your eligible
                    amount. A 2% processing fee is deducted from each withdrawal.
                    Funds are paid to the bank or PayPal account you nominate.
                  </li>
                  <li>
                    <strong>Important</strong>
                    <br />
                    All payouts are subject to account checks, transaction
                    validation, and these Terms and Conditions. If the
                    underlying transaction is cancelled, reversed, refunded, or
                    found to be invalid, the related TopCoin and payout
                    eligibility may also be cancelled or adjusted.
                  </li>
                </ul>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">10. Refunds and returns</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  If a transaction that earned TopCoin is refunded or cancelled,
                  the corresponding TopCoin will be removed from all related
                  balances, and your Cash Wallet amount may be adjusted.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  11. Account suspension and closure
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  We may suspend or close an account for fraud, abuse, or breach
                  of these Terms. You may close your account at any time by
                  emailing info@topcoinuk.com.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">12. Data and privacy</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  Your data is processed under our Privacy Policy. Only the
                  minimum data required to execute withdrawals is shared with
                  our FCA-authorised payment partner.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">13. Liability</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  We are not liable for merchant failures, unauthorised access
                  caused by insecure credentials, or indirect losses. Our total
                  liability is limited to the sterling value of TopCoin in your
                  account at the time of any claim.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">14. Changes to these Terms</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  We may update these Terms with 30 days’ notice by email or
                  on-site notice. Continued use after the effective date
                  constitutes acceptance.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">15. Governing law</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  These Terms are governed by English law. Any disputes are
                  subject to the courts of England & Wales.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">Need help?</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  Email: <strong>info@topcoinuk.com</strong>
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK Ltd is an advertising, rewards, and discount company.
                  It is not a cryptocurrency, gambling, or investment business.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaptainTCCashbackCardTerms;
